const LineGradient = ({ width = "w-full" }) => {
    return <div className={`h-0.5 mt-10 ${width} bg-gradient-rainblue`} />;
  };
  
  export default LineGradient;